import { useEffect } from 'react';

import {
  useGetApplicationQuery,
  useGetContext,
  useGetProfile,
} from '../lendingApi/lendingApiQueries';
import { identifyTrackingProperties } from '../utils/trackingSetup.helpers';

export function useSetupAmplitude() {
  const { application } = useGetApplicationQuery();
  const { profile } = useGetProfile();
  const { context } = useGetContext();

  // Only want to identify on initial fetch, not update
  const hasApplication = Boolean(application);
  const hasProfile = Boolean(profile);
  const hasContext = Boolean(context);

  useEffect(() => {
    if (hasApplication && hasProfile && hasContext) {
      identifyTrackingProperties({ context, profile, application });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasApplication, hasProfile, hasContext]);
}
